export default __webpack_public_path__ + "static/media/photo--lg--kara.eac82dd2.jpg";